<template>
    <EmployeeTrackLiquidation></EmployeeTrackLiquidation>
</template>
<script>
    import EmployeeTrackLiquidation from '@/components/EmployeeTrackLiquidation.vue'
    export default {
        name: 'employee-track-liquidation',
        components: {
            EmployeeTrackLiquidation
        }
    }
</script>